import { render, staticRenderFns } from "./CustomFieldDate.vue?vue&type=template&id=2bdc2576"
import script from "./CustomFieldDate.vue?vue&type=script&lang=ts"
export * from "./CustomFieldDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports